import { entries, isArray, isPlainObject, get, isEmpty } from 'lodash-es';

import * as analyticsUtils from './utils';
import viewProperties from 'configFolderAlias/analytics/view.json';
import eventProperties from 'configFolderAlias/analytics/event.json';
const debug = (...args) => {
  if (typeof __DEV__ !== 'undefined' && __DEV__) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};
export const trackPageView = (action) => {
  debug('viewProperties', viewProperties);
  const { eventPropertiesAtKeyPath } = analyticsUtils.getPropertiesAtKeyPath(
    action,
    viewProperties
  );

  if (eventPropertiesAtKeyPath) {
    const payload = {
      ...eventPropertiesAtKeyPath,
      tealium_event: 'view',
    };

    if (__DEV__) {
      // eslint-disable-next-line no-console
      debug('window.TMS.trackView', payload);
    }
    debug('trackPageView window.TMS--:', window.TMS);
    if (window.TMS) {
      window.TMS.trackView(payload);
    }
  }

  return null;
};

const trackEvent = (eventProperties) => {
  const payload = {
    ...eventProperties,
    tealium_event: 'link',
  };

  if (__DEV__) {
    // eslint-disable-next-line no-console
    debug('window.TMS.trackEvent', payload);
  }
  debug('trackEvent window.TMS:', window.TMS);
  if (window.TMS) {
    window.TMS.trackEvent(payload);
  }
};

export const trackEventAtKeyPath = (action) => {
  debug('trackEventAtKeyPath eventProperties', eventProperties);
  const eventPropertiesForType = get(eventProperties, `${action.type}`, {});
  const eventPropertiesForName = get(
    eventPropertiesForType,
    `${action.name}`,
    {}
  );
  debug('eventPropertiesForType', eventPropertiesForType);
  debug('eventPropertiesForName', eventPropertiesForName);
  if (!isEmpty(eventPropertiesForName)) {
    const { eventPropertiesAtKeyPath } = analyticsUtils.getPropertiesAtKeyPath(
      action,
      eventPropertiesForType
    );
    debug('eventPropertiesAtKeyPath', eventPropertiesAtKeyPath);
    if (eventPropertiesAtKeyPath) {
      return trackEvent(eventPropertiesAtKeyPath);
    }
  }
  return null;
};

export const trackEventsForPage = (pageName, action) => {
  debug('trackEventsForPage eventProperties', eventProperties);
  return (function recurse(keyPath) {
    const { formValuesAtKeyPath, eventPropertiesAtKeyPath } =
      analyticsUtils.getPropertiesAtKeyPath(
        {
          ...action,
          keyPath,
        },
        eventProperties
      );

    if (isArray(formValuesAtKeyPath)) {
      return formValuesAtKeyPath.forEach((_, index) => {
        recurse(analyticsUtils.extendKeyPath(keyPath, { index }));
      });
    }

    if (
      typeof formValuesAtKeyPath !== 'undefined' &&
      formValuesAtKeyPath !== null &&
      eventPropertiesAtKeyPath
    ) {
      return trackEvent(eventPropertiesAtKeyPath);
    }

    if (isPlainObject(formValuesAtKeyPath)) {
      return entries(formValuesAtKeyPath).forEach(([propertyName]) => {
        recurse(analyticsUtils.extendKeyPath(keyPath, { propertyName }));
      });
    }

    return null;
  })({ pageName });
};
